import { DsdttinhluongService } from 'src/services/dsdttinhluong.service';
import { showToast } from 'src/utils/common';
import {
    DEFAULT_ROW_PER_PAGE,
  } from 'src/utils/constants';

import { AppAction } from './app.action';

export const DSDTTINHLUONG_UPDATE_FILTER = 'DSDTTINHLUONG:DSDTTINHLUONG_UPDATE_FILTER'

export const DSDTTINHLUONG_NEW_CARE_SUCCESS = 'DSDTTINHLUONG:NEW_CARE_SUCCESS'
export const DSDTTINHLUONG_LIST_SUCCESS = 'DSDTTINHLUONG:FIND_ALL_SUCCESS'
export const DSDTTINHLUONG_LIST_FAILD = 'DSDTTINHLUONG:FIND_ALL_FAILD'
export const DSDTTINHLUONG_COUNT_ASSIGN_SUCCESS = 'DSDTTINHLUONG:COUNT_ASSIGN_SUCCESS'
export const DSDTTINHLUONG_COUNT_ASSIGN_FAILD = 'DSDTTINHLUONG:COUNT_ASSIGN_FAILD'

export const DSDTTINHLUONG_CREATE_SUCCESS = 'DSDTTINHLUONG:CREATE_SUCCESS'
export const DSDTTINHLUONG_CREATE_FAILD = 'DSDTTINHLUONG:CREATE_FAILD'

export const DSDTTINHLUONG_IMPORT_SUCCESS = 'DSDTTINHLUONG:IMPORT_SUCCESS'
export const DSDTTINHLUONG_SAVE_SUCCESS = 'DSDTTINHLUONG:SAVE_SUCCESS'
export const DSDTTINHLUONG_SAVE_FAILD = 'DSDTTINHLUONG:SAVE_SUCCESS'

export const DSDTTINHLUONG_DEL_SUCCESS = 'DSDTTINHLUONG:DEL_SUCCESS'
export const DSDTTINHLUONG_DEL_FAILD = 'DSDTTINHLUONG:DEL_FAILD'


export const DSDTTINHLUONG_HISTORY_LIST_SUCCESS = 'DSDTTINHLUONG:HISTORY_FIND_ALL_SUCCESS'
export const DSDTTINHLUONG_HISTORY_LIST_FAILD = 'DSDTTINHLUONG:HISTORY_FIND_ALL_FAILD'

export const DSDTTINHLUONG_LIST_EXPORT_SUCCESS = 'DSDTTINHLUONG:FIND_ALL_EXPORT_SUCCESS'
export const DSDTTINHLUONG_LIST_EXPORT_FAILD = 'DSDTTINHLUONG:FIND_ALL_EXPORT_FAILD'

export const DsdttinhluongAction = {
    list,
    listExport,
    findAssign,
    create,
    updateFilter,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    updateUser,
}


function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { dsdttinhluong } = getState()
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...dsdttinhluong.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_LIST_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { dsdttinhluong } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = dsdttinhluong;
        
        DsdttinhluongService.findAll(filter.page, filter.limit, filter).then((rs) => {
            if (!!filter && filter.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count,
                    tongDoanhThu: rs.data.tongDoanhThu,
                    tongGoi: rs.data.tongGoi,
                    tongGiaTriGoi: rs.data.tongGiaTriGoi,
                    tongSoTienHoan: rs.data.tongSoTienHoan,
                }));
            } else {
                dispatch(success({
                    items: [...dsdttinhluong.items, ...rs.data.values],
                    total: rs.data.count,
                    tongDoanhThu: rs.data.tongDoanhThu,
                    tongGoi: rs.data.tongGoi,
                    tongGiaTriGoi: rs.data.tongGiaTriGoi,
                    tongSoTienHoan: rs.data.tongSoTienHoan,
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_LIST_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_LIST_FAILD, error } }
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { dsdttinhluong } = getState();

            const { filter } = dsdttinhluong;

            // Perform your asynchronous operation (e.g., API call)
            DsdttinhluongService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: DSDTTINHLUONG_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_LIST_EXPORT_FAILD, error } }
}

function updateFilter(payload) {
    return { type: DSDTTINHLUONG_UPDATE_FILTER, data: payload }
}

function importData(payload) {
    return { type: DSDTTINHLUONG_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            DsdttinhluongService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(DsdttinhluongAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: DSDTTINHLUONG_SAVE_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_SAVE_FAILD, error } }
}

function update(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(DsdttinhluongAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_CREATE_FAILD, error } }
}

function updateUser(username, track0, track1) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.updateUser(username, track0, track1).then((rs) => {
            
        }).catch((error) => {
            
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(DsdttinhluongAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(DsdttinhluongAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_DEL_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_DEL_FAILD, error } }
}


function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(DsdttinhluongAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { dsdttinhluong } = getState()
        dispatch(AppAction.appLoading(true));
        DsdttinhluongService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...dsdttinhluong.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: DSDTTINHLUONG_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: DSDTTINHLUONG_HISTORY_LIST_FAILD, error } }
}